export default class Rels {
    Relationships;
    rIdNum;
    BaseDoc;

    constructor() {
        this.BaseDoc = document.implementation.createDocument(null, null, null);
        this.Relationships = this.BaseDoc.createElement('Relationships');
        this.BaseDoc.appendChild(this.Relationships);
        this.Relationships.setAttribute('xmlns', 'http://schemas.openxmlformats.org/package/2006/relationships');
        this.rIdNum = 1;
    }

    addImage(imgPath) {
        let Relationship = this.BaseDoc.createElement('Relationship');
        this.Relationships.appendChild(Relationship);
        Relationship.setAttribute('Type', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image');
        Relationship.setAttribute('Id', 'rId' + this.rIdNum);
        Relationship.setAttribute('Target', imgPath);
        this.rIdNum = this.rIdNum + 1;
    }

    getString() {
        let xmlText = new XMLSerializer().serializeToString(this.BaseDoc);
        xmlText = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + xmlText;
        return xmlText;
    }
    
}


// WEBPACK FOOTER //
// ./src/javascript-classes/JS-DOCX/rels.js